// src/components/ExamCard.jsx
// ───────────────────────────────────────────────────────────────────────────
//  La tarjeta de EXAMEN al final de un nivel del curso. Vive en la misma
//  cuadrícula que las lecciones (.lc-topics-grid), pero se distingue: es la meta
//  del nivel, no una lección más. Aparece solo si hay un examen PUBLICADO para
//  ese nivel; si no, el hueco queda vacío.
// ───────────────────────────────────────────────────────────────────────────
import React from 'react';
import { Link } from 'react-router-dom';
import './ExamCard.css';

const ExamCard = React.memo(({ code, title, nReactivos }) => (
  <Link to={`/examenes?code=${encodeURIComponent(code)}`}
        className="lsc-topic-card exc-card">
    <div className="lsc-topic-flag exc-flag">🎓</div>
    <div className="lsc-topic-content">
      <div className="lsc-topic-title">{title}</div>
      <p className="lsc-topic-status-text exc-status">
        Examen de nivel{nReactivos ? ` · ${nReactivos} preguntas` : ''}
      </p>
    </div>
    <div className="lsc-completion-indicator exc-ind" aria-hidden="true">→</div>
  </Link>
));

export default ExamCard;
